import React, { Component } from 'react'
import { Modal } from 'react-bootstrap'
import PropTypes from 'prop-types'
import FormComponent from 'dataphi-react-components/dist/Containers/FormScreen/FormComponent'


const HSGPopupBackdropStyle = {
    top: 0,
    backgroundColor: '#000',
    opacity: 0.5
}

export default class HSGPopupComponent extends Component{

    getPopUpHeader = (headerText) => headerText ? <div className='hsg-card-header-label wide'>{headerText}</div> : null

    getForm = ({formDefs, onClose, onSubmit, onFieldBlur}) => (
        <FormComponent
            onClose={onClose}
            onSubmit={onSubmit}
            formDefs={formDefs}
            onFieldBlur={onFieldBlur}
        />
    )

    getButtonActions = (e, onClick) => {
        e.preventDefault()
        onClick && onClick(e)
        this.props.onHide && this.props.onHide()
    } 

    getButtons = (buttons) => (
        <div className="text-right">
            {buttons.map((button,i)=>(
                <button 
                    key={i} 
                    className={button.className || 'hsg-btn'} 
                    onClick={e=>this.getButtonActions(e, button.onClick)}>
                    {button.text}
                </button>)
            )}
        </div>
    )

    getBody = (bodyText, buttons) => bodyText ? <div>
        {bodyText} 
        {buttons && buttons.length && this.getButtons(buttons)}
    </div> : null

    render = () => {
        const {props} = this
        return (
            <Modal
                className="hsg-modal"
                show={props.show}
                onHide={props.onHide}
                backdropStyle={HSGPopupBackdropStyle}
            >
                <Modal.Header>
                    {this.getPopUpHeader(props.header)}
                </Modal.Header>
                <Modal.Body>
                    {props.isForm ? this.getForm(props) : this.getBody(props.body, props.buttons)}
                </Modal.Body>
            </Modal>
        )
    }
}

HSGPopupComponent.defaultProps = {
    isForm: false
}

HSGPopupComponent.propTypes = {
    formDefs: PropTypes.object,
    onClose: PropTypes.func,
    onSubmit: PropTypes.func,
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func,
    header: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    isForm: PropTypes.bool.isRequired,
    body: PropTypes.object,
    buttons: PropTypes.arrayOf(PropTypes.shape({
        className: PropTypes.string,
        onClick: PropTypes.func.isRequired,
        text: PropTypes.string.isRequired
    }))
}


// WEBPACK FOOTER //
// ./src/Containers/AppContainer/Component/HSGPopupComponent.js